import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from './Modal';
import { WettkampfSignaturen } from '../api/apiClient';

function formatGermanDate(v) {
  if (!v) return '-';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? '-' : d.toLocaleDateString('de-DE');
}

/**
 * Zeigt nach dem Login einmal einen Hinweis, wenn eine eigene Mannschaft
 * (per Mannschaftsmitgliedschaft) noch bei einem Wettkampf im Status
 * "Unterschrift" auf die digitale Bestätigung wartet.
 */
function AusstehendeSignaturenModal({ currentUser }) {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser?.schuetzenId) return;
    let cancelled = false;
    WettkampfSignaturen.getAusstehend()
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : [];
        setItems(list);
        if (list.length > 0) setShow(true);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [currentUser?.schuetzenId]);

  const goTo = (item) => {
    setShow(false);
    navigate(`/saison/${item.saisonId}/wettkampf/${item.nummer}/ergebnis`);
  };

  if (items.length === 0) return null;

  return (
    <Modal show={show} onHide={() => setShow(false)} size="sm">
      <Modal.Header onClose={() => setShow(false)}>Unterschrift ausstehend</Modal.Header>
      <Modal.Body>
        <p className="text-sm text-slate-600 mb-3">
          Für {items.length === 1 ? 'folgenden Wettkampf fehlt' : 'folgende Wettkämpfe fehlt'} noch deine digitale Unterschrift:
        </p>
        <ul className="space-y-2">
          {items.map((item) => (
            <li key={`${item.wettkampfId}-${item.seite}`}>
              <button
                onClick={() => goTo(item)}
                className="w-full text-left rounded-lg border border-slate-200 px-3 py-2 hover:bg-slate-50 text-sm"
              >
                Wettkampf Nr. {item.nummer ?? '-'}
                {item.runde != null && <> · Runde {item.runde}</>}
                {' · '}{formatGermanDate(item.datum)}
              </button>
            </li>
          ))}
        </ul>
      </Modal.Body>
    </Modal>
  );
}

export default AusstehendeSignaturenModal;
